module.exports = __webpack_public_path__ + "img/unlimited-tagged.ef70553d.png";